import api from "Common/Client/Interceptor";

export const organizationService = {
  // Get organization list
  getOrganizationList: async () => {
    try {
      const response = await api.get("/Tenant/Get-List?filter=0");
      console.log(" Organization list fetched:", response.data);
      return response.data;
    } catch (error) {
      console.error(" Error fetching organization list:", error);
      throw error;
    }
  },

  // Check available databases
  getAvailableDatabases: async () => {
    try {
      const response = await api.get("/Tenant/available-databases");
      console.log(" Available databases:", response.data);
      return response.data;
    } catch (error) {
      console.error(" Error fetching available databases:", error);
      throw error;
    }
  },

  // Assign database to tenant
  assignDatabase: async (tenantId, databaseId) => {
    try {
      const response = await api.post("/Tenant/assign-database", {
        tenantId: tenantId,
        databaseId: databaseId
      });
      console.log(" Database assigned:", response.data);
      return response.data;
    } catch (error) {
      console.error(" Error assigning database:", error);
      throw error;
    }
  },

  // Approve organization (combines database check and assignment)
  approveOrganization: async (orgId) => {
    try {
      // First check available databases
      const databases = await organizationService.getAvailableDatabases();
      
      if (!databases || databases.length === 0) {
        throw new Error("No available databases found");
      }

      // Use the first available database
      const firstDatabase = databases[0];
      
      // Assign database to tenant
      const result = await organizationService.assignDatabase(orgId, firstDatabase.id);
      
      return result;
    } catch (error) {
      console.error(" Error approving organization:", error);
      throw error;
    }
  },

   getOrganizationDetails : async (tenantId) => {
  try {
    const response = await api.get(`/Tenant/Get-Detail?tenantId=${tenantId}`);
    console.log("..........detaiol org", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching organization details:', error);
    throw error;
  }
}
}
